import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
  selector: "app-fly-icon",
  templateUrl: "./fly-icon.component.html",
  styleUrls: ["./fly-icon.component.css"],
})
export class FlyIconComponent implements OnInit {
  @Input() url = "https://wa.me/545602139?text=";
  @Input() message =
    "היי ראיתי אתכם באתר ואני מעוניין בפרטים נוספים לגבי מסך לעסק";
  @Output() onClickFlyIcon = new EventEmitter();
  constructor() {}

  link = "";
  ngOnInit(): void {
    this.link = this.url + this.message;
  }
  clickFlyIcon() {
    this.onClickFlyIcon.emit();
  }
}
